import Axios from 'axios'
import {
  API_ROOT
} from '../../config'

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000

});
console.log(API_ROOT);

export default {
  state: {
    verzuim: []
  },
  mutations: {
    VERZUIM(state, obj) {

      _.merge(state.verzuim, obj);
      console.log('VERZUIM commit!');
      console.log(state);
    }
  },
  getters: {
    get_verzuim(state) {
      return state.verzuim;
    }
  },
  actions: {
    verzuim(context, obj) {
      console.log('Set vezuim ' + obj.length);
      console.log(obj);
      context.commit('VERZUIM', obj);
    }
  }
}
